import React, { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
  CircularProgress,
  Link,
  InputAdornment,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import imageCompression from 'browser-image-compression';

import { ToastContainer , toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: 'url("https://i.pinimg.com/736x/cc/99/40/cc9940ea77bcddcfda6752828e2cd966.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    padding: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(4),
    borderRadius: "10px",
    backgroundColor: "#3282B8",
    maxWidth: "800px",
    padding: "15px",
    minHeight: "400px",
    borderRadius: "5px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
      maxWidth: "90%",
      marginTop: "150px",
    },
  },
  form: {
    width: "100%",
  },
  row: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: theme.spacing(2),
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  textField: {
    minHeight: "40px",
    flex: "1 1 100%",
    "& .MuiFilledInput-root": {
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      borderRadius: "5px",
    },
    "& .MuiInputBase-input": {
      color: "black",
    },
    "& .MuiFormHelperText-root": {
      color: "red",
    },
    [theme.breakpoints.up("md")]: {
      flex: "1 1 calc(50% - 16px)",
    },
  },
  formControl: {
    minHeight: "40px",
    flex: "1 1 100%",
    "& .MuiSelect-root": {
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      borderRadius: "5px",
    },
    [theme.breakpoints.up("md")]: {
      flex: "1 1 calc(50% - 16px)",
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#0F4C75",  /* Deep Blue to match image */
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#3282B8",  /* Vibrant Sky Blue on hover */
    },
    position: "relative",
    height: "45px",  /* Slightly increased height for better UI */
    fontSize: "15px",  /* Slightly larger font for readability */
    fontWeight: "bold", /* Bold text for better contrast */
    borderRadius: "8px", /* Smooth rounded edges for a modern look */
    marginTop: "12px",
    marginBottom: "12px",
    width: "120px", /* Slightly wider for a better button shape */
    marginLeft: "auto",
    marginRight: "auto",
    display: "block",
    transition: "0.3s ease-in-out", /* Smooth transition on hover */
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)", /* Soft shadow for depth */
  },

  loader: {
    color: "#FFFFFF",
  },
  uploadInput: {
    display: "none",
  },
  uploadLabel: {
    marginTop: theme.spacing(1),
    color: "white",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    borderRadius: "5px",
    padding: theme.spacing(1),
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },
  fileName: {
    color: "white",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "150px",
  },
  uploadContainer: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
}));






const OrganizationForm = () => {

  const classes = useStyles();
  const [values, setValues] = useState({
    schoolLogo: null,
    role: "ORGANIZATION",
    schoolName: "",
    primaryContact: "",
    secondaryContact:"",
    schoolEmailId: "",
    schoolAddress: "",
    boardAffiliation: "",
    schoolType:"",
    affiliationNumber:"",
    state: "",
    city: "",
    pincode: "",
    prefixIds:"",
    feature:'',
    plan:'',
    schoolStamp: null,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  // const [schoolLogoName, setschoolLogoName] = useState("No file chosen"); // Add state for company logo name
  // const [schoolStampName, setschoolStampName] = useState("No file chosen"); // Add state for company stamp name
  const [schoolLogoName, setSchoolLogoName] = useState("No file chosen");
  const [schoolStampName, setSchoolStampName] = useState("No file chosen");
  const navigate = useNavigate();

  

  const stateOptions = [
    { value: "Andhra Pradesh", label: "Andhra Pradesh" },
    { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
    { value: "Assam", label: "Assam" },
    { value: "Bihar", label: "Bihar" },
    { value: "Chhattisgarh", label: "Chhattisgarh" },
    { value: "Goa", label: "Goa" },
    { value: "Gujarat", label: "Gujarat" },
    { value: "Haryana", label: "Haryana" },
    { value: "Himachal Pradesh", label: "Himachal Pradesh" },
    { value: "Jharkhand", label: "Jharkhand" },
    { value: "Karnataka", label: "Karnataka" },
    { value: "Kerala", label: "Kerala" },
    { value: "Madhya Pradesh", label: "Madhya Pradesh" },
    { value: "Maharashtra", label: "Maharashtra" },
    { value: "Manipur", label: "Manipur" },
    { value: "Meghalaya", label: "Meghalaya" },
    { value: "Mizoram", label: "Mizoram" },
    { value: "Nagaland", label: "Nagaland" },
    { value: "Odisha", label: "Odisha" },
    { value: "Punjab", label: "Punjab" },
    { value: "Rajasthan", label: "Rajasthan" },
    { value: "Sikkim", label: "Sikkim" },
    { value: "Tamil Nadu", label: "Tamil Nadu" },
    { value: "Telangana", label: "Telangana" },
    { value: "Tripura", label: "Tripura" },
    { value: "Uttar Pradesh", label: "Uttar Pradesh" },
    { value: "Uttarakhand", label: "Uttarakhand" },
    { value: "West Bengal", label: "West Bengal" },
  ];
  

  const boardAffiliationOptions = [
    
    { value: "SSC", label: "SSC" },
    { value: "INTERMEDIATE", label: "INTERMEDIATE" },
    // { value: "CBSE", label: "CBSE" },
    // { value: "StateBoard", label: "State Board" },
    
  ];
  const schoolTypeOptions = [
    { value: "Public", label: "Public" },
    { value: "Private", label: "Private" },
    { value: "International", label: "International" },
    { value: "Other", label: "Other" },
    
  ];
  

  const validate = () => {
    const newErrors = {};

    // Check if Company Name is provided
    if (!values.schoolName) newErrors.schoolName = "School Name is required";

    // Check if Company Email is provided and valid
    if (!values.schoolEmailId) {
      newErrors.schoolEmailId = "School Email is required";
    } else if (!/\S+@\S+\.\S+/.test(values.schoolEmailId)) {
      newErrors.schoolEmailId = "Invalid email address";
    }

    // Check if Primary Contact Number is provided and valid
    if (!values.primaryContact) {
      newErrors.primaryContact = "Primary Contact Number is required";
    } else if (!/^\d{10}$/.test(values.primaryContact)) {
      newErrors.primaryContact = "Primary Contact Number must be 10 digits";
    }

    // Check if Secondary Contact Number is provided and valid
    if (!values.secondaryContact) {
      newErrors.secondaryContact = "Secondary Contact Number is required";
    } else if (!/^\d{10}$/.test(values.secondaryContact)) {
      newErrors.secondaryContact = "Secondary Contact Number must be 10 digits";
    }

    // Check if affiliationNumber Number is provided and valid
    // if (!values.affiliationNumber) {
    //   newErrors.affiliationNumber = "Affiliation Number is required";
    // }

    // Check if Company Address is provided
    if (!values.schoolAddress)
      newErrors.schoolAddress = "School Address is required";

    // Check if Business Type is selected
    if (!values.boardAffiliation)
      newErrors.boardAffiliation = "Affiliation Type is required";

     // Check if schoolType Type is selected
     if (!values.schoolType)
      newErrors.schoolType = "School Type is required";

    // Check if State is selected
    if (!values.state) newErrors.state = "State is required";

    // Check if feature is selected
    if (!values.feature) newErrors.feature = "Feature is required";

     // Check if plan is selected
     if (!values.plan) newErrors.plan = "Plan is required";


    // Check if City is provided
    if (!values.city) newErrors.city = "City is required";

    if (!values.prefixIds) newErrors.prefixIds = "Prefix Id is required";

    // Check if pinCode is provided and valid
    if (!values.pincode) {
      newErrors.pincode = "pinCode is required";
    } else if (!/^\d{6}$/.test(values.pincode)) {
      newErrors.pincode = "pinCode must be 6 digits";
    }

    // Validate Company Logo file
    if (!values.schoolLogo) {
      newErrors.schoolLogo = "School Logo is required";
    } else if (!["image/jpeg", "image/png"].includes(values.schoolLogo.type)) {
      newErrors.schoolLogo = "School Logo must be a JPEG or PNG image Format";
    } else if (values.schoolLogo.size > 1 * 1024 * 1024) {
      // 1MB limit
      newErrors.schoolLogo = "School Logo must be less than 1MB";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  


const handleSubmit = async (event) => {
  event.preventDefault();
  if (!validate()) return;

  setLoading(true);
  try {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const formData = new FormData();

    // Compress Company Logo if present
    if (values.schoolLogo) {
      const compressedLogo = await compressImage(values.schoolLogo);
      formData.append("schoolLogo", compressedLogo, compressedLogo.name);
    }

    // Compress Company Stamp if present
    if (values.schoolStamp) {
      const compressedStamp = await compressImage(values.schoolStamp);
      formData.append("schoolStamp", compressedStamp, compressedStamp.name);
    }

  
    // Append other form data with +91 for primaryContact
    // Object.keys(values).forEach((key) => {
    //   if (key === "primaryContact") {
    //     const contact = values.primaryContact;
    //     const formattedContact = contact.startsWith("91") ? contact : `91${contact}`;
    //     formData.append("primaryContact", formattedContact);
    //   } else if (values[key] instanceof File) {
    //     formData.append(key, values[key]);
    //   } else {
    //     formData.append(key, values[key]);
    //   }
    // });
    // Append other form data with cleaned +91 logic for primaryContact
    Object.keys(values).forEach((key) => {
      if (key === "primaryContact") {
        let contact = values.primaryContact?.toString().replace(/\D/g, ""); // Remove non-digits

        if (contact.length === 10) {
          formData.append("primaryContact", `91${contact}`);
        } else if (contact.length === 12 && contact.startsWith("91")) {
          formData.append("primaryContact", contact);
        } else {
          // Invalid number, skip appending or handle as needed
          console.warn("Invalid contact number format");
        }
      } else if (values[key] instanceof File) {
        formData.append(key, values[key]);
      } else {
        formData.append(key, values[key]);
      }
    });

    // Make the API call
    const response = await fetch(
      `${baseUrl}/api/v1/organisation/saveOrganisation`,
      {
        method: "POST",
        body: formData,
      }
    );

    const responseData = await response.json(); // ✅ Parse response JSON only once

    // Handle the response
    if (response.ok) {
      toast.success("Organization registered successfully!", {
        autoClose: 1000,
        onClose: () => navigate("/"), // ✅ Navigate only after toast disappears
      });
    } else {
      const errorMessage =
        responseData?.error_message || "Error submitting the form.";
      console.error("Error submitting the form:", errorMessage);

      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 2000,
      });
    }
  } catch (error) {
    console.error("Submission error:", error);
    toast.error(`Registration failed: ${error.message}`, { autoClose: 2000 });
  } finally {
    setLoading(false);
  }
};

  
  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 1, // Max size in MB
      maxWidthOrHeight: 1024, // Max width or height
      useWebWorker: true
    };
    return imageCompression(file, options);
  };
  

  //new handlechange code
  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues((prev) => ({ ...prev, [name]: value }));

    // Clear the error for this field if it is valid
    if (errors[name]) {
      const newErrors = { ...errors };
      delete newErrors[name];
      setErrors(newErrors);
    }
  };

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    const file = files[0];
  
    if (file) {
      // ✅ Update the form values state
      setValues((prev) => ({ ...prev, [name]: file }));
  
      // ✅ Update file name state dynamically
      if (name === "schoolLogo") {
        setSchoolLogoName(file.name);
      } else if (name === "schoolStamp") {
        setSchoolStampName(file.name);
      }
  
      // ✅ Clear the error for this field if the file is valid
      if (errors[name]) {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          delete newErrors[name];
          return newErrors;
        });
      }
    } else {
      // If no file is selected, reset the file name
      if (name === "schoolLogo") {
        setSchoolLogoName("No file chosen");
      } else if (name === "schoolStamp") {
        setSchoolStampName("No file chosen");
      }
    }
  };
  

 

  return (
    <div className={classes.root}>
          <Container
            component="main"
            className={classes.container}
            style={{
              maxWidth: "800px",
              padding: "15px",
              minHeight: "400px",
              borderRadius: "5px",
            }} // Reduce overall height and width
          >
        <Typography
          variant="h5"
          align="center"
          style={{ color: "white", marginBottom: "20px",fontWeight: "bold", }}
        >
          Organization Registration Form
        </Typography>
        <form onSubmit={handleSubmit} className={classes.form}>
        <Box
          className={classes.row}
          style={{
            display: "flex",
            justifyContent: "space-between", // Space between fields
            gap: "10px", // Add gap between fields (adjust as needed)
          }}
        >
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Organization Name*"
            onChange={handleChange}
            value={values.schoolName}
            name="schoolName"
            autoComplete="off"
            error={!!errors.schoolName}
            helperText={errors.schoolName}
            className={classes.textField}
            size="small"
            style={{ flex: 1 }} // Each field takes equal width
          />

          <TextField
            fullWidth
            variant="filled"
            type="email"
            label="Email*"
            onChange={handleChange}
            value={values.schoolEmailId}
            name="schoolEmailId"
            autoComplete="off"
            error={!!errors.schoolEmailId}
            helperText={errors.schoolEmailId}
            className={classes.textField}
            size="small"
            style={{ flex: 1 }} // Each field takes equal width
          />

          
        </Box> 

        <Box
            className={classes.row}
            style={{
              display: "flex",
              justifyContent: "space-between", // Space between fields
              gap: "10px", // Add gap between fields (adjust as needed)
            }}
          >

<TextField
            fullWidth
            variant="filled"
            type="number"
            label="Primary Contact Number*"
            onChange={handleChange}
            value={values.primaryContact}
            name="primaryContact"
            autoComplete="off"
            error={!!errors.primaryContact}
            helperText={errors.primaryContact}
            className={classes.textField}
            size="small"
            style={{ flex: 1 }} // Each field takes equal width
            InputProps={{
    startAdornment: <InputAdornment position="start">+91</InputAdornment>,
  }}
          />

            <TextField
              fullWidth
              variant="filled"
              type="number"
              label="Secondary Contact Number*"
              onChange={handleChange}
              value={values.secondaryContact}
              name="secondaryContact"
              autoComplete="off"
              error={!!errors.secondaryContact}
              helperText={errors.secondaryContact}
              className={classes.textField}
              size="small"
              style={{ flex: 1 }} // Equal width for this field
            />

            <FormControl
              fullWidth
              variant="filled"
              error={!!errors.schoolType}
              className={classes.formControl}
              size="small"
              style={{ flex: 1 }} // Equal width for this field
            >
              <InputLabel>Organization Type</InputLabel>
              <Select
                value={values.schoolType}
                onChange={handleChange}
                name="schoolType"
              >
                {schoolTypeOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
              {errors.schoolType && (
                <FormHelperText>{errors.schoolType}</FormHelperText>
              )}
            </FormControl>

            
        </Box>

        <Box
          className={classes.row}
          style={{
            display: "flex",
            justifyContent: "space-between", // Space between fields
            gap: "10px", // Add gap between fields (adjust as needed)
          }}
        >

<FormControl
              fullWidth
              variant="filled"
              error={!!errors.boardAffiliation}
              className={classes.formControl}
              size="small"
              style={{ flex: 1 }} // Equal width for this field
            >
              <InputLabel>Board Affiliation*</InputLabel>
              <Select
                value={values.boardAffiliation}
                onChange={handleChange}
                name="boardAffiliation"
              >
                {boardAffiliationOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
              {errors.boardAffiliation && (
                <FormHelperText>{errors.boardAffiliation}</FormHelperText>
              )}
            </FormControl>

          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Affiliation No"
            onChange={handleChange}
            value={values.affiliationNumber}
            name="affiliationNumber"
            autoComplete="off"
            className={classes.textField}
            size="small"
            style={{ flex: 1 }} // Equal width for this field
          />

          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Address*"
            onChange={handleChange}
            value={values.schoolAddress}
            name="schoolAddress"
            autoComplete="off"
            error={!!errors.schoolAddress}
            helperText={errors.schoolAddress}
            className={classes.textField}
            size="small"
            style={{ flex: 1 }} // Equal width for this field
          />

          
        </Box>

          <Box className={classes.row} style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
            <FormControl
              variant="filled"
              error={!!errors.state}
              className={classes.formControl}
              size="small"
              style={{ flex: 1 }} // Equal width for this field
            >
              <InputLabel>State</InputLabel>
              <Select value={values.state} onChange={handleChange} name="state">
                {stateOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
              {errors.state && <FormHelperText>{errors.state}</FormHelperText>}
            </FormControl>

            <TextField
              variant="filled"
              type="text"
              label="City*"
              onChange={handleChange}
              value={values.city}
              name="city"
              autoComplete="off"
              error={!!errors.city}
              helperText={errors.city}
              className={classes.textField}
              size="small"
              style={{ flex: 1 }} // Equal width for this field
            />

            <TextField
              variant="filled"
              type="number"
              label="Pincode"
              onChange={handleChange}
              value={values.pincode}
              name="pincode"
              error={!!errors.pincode}
              helperText={errors.pincode}
              className={classes.textField}
              size="small"
              style={{ flex: 1 }} // Equal width for this field
            />
          </Box>



          <Box
  className={classes.row}
  style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}
>
<TextField
  variant="filled"
  type="text"
  label="Prefix Id*"
  placeholder="eg:STU (3-letter Org Code)"
  name="prefixIds"
  value={values.prefixIds}
  onChange={(e) => {
    const input = e.target.value.toUpperCase();

    // Allow only alphabets and limit to 3 characters
    if (/^[A-Z]{0,3}$/.test(input)) {
      // Create a synthetic event with uppercased value
      const syntheticEvent = {
        ...e,
        target: {
          ...e.target,
          value: input,
          name: "prefixIds",
        },
      };
      handleChange(syntheticEvent);
    }
  }}
  autoComplete="off"
  error={!!errors.prefixIds}
  helperText={errors.prefixIds}
  className={classes.textField}
  size="small"
  style={{ flex: 1 }}
/>

  <FormControl
    variant="filled"
    error={!!errors.feature}
    className={classes.formControl}
    size="small"
    style={{ flex: 1 }}
  >
    <InputLabel>Features*</InputLabel>
    <Select value={values.feature} onChange={handleChange} name="feature">
      <MenuItem value="LITE">LITE</MenuItem>
      <MenuItem value="CORE">CORE</MenuItem>
      <MenuItem value="ULTRA">ULTRA</MenuItem>
    </Select>
    {errors.feature && <FormHelperText>{errors.feature}</FormHelperText>}
  </FormControl>

<FormControl
    variant="filled"
    error={!!errors.plan}
    className={classes.formControl}
    size="small"
    style={{ flex: 1 }}
  >
    <InputLabel>Plans*</InputLabel>
    <Select value={values.plan} onChange={handleChange} name="plan">
       <MenuItem value="SILVER">SILVER</MenuItem>
      <MenuItem value="GOLD">GOLD</MenuItem>
      <MenuItem value="PLATINUM">PLATINUM</MenuItem>
      <MenuItem value="DIAMOND">DIAMOND</MenuItem>
    </Select>
    {errors.plan && <FormHelperText>{errors.plan}</FormHelperText>}
  </FormControl>



  
</Box>


         
          <Box
            className={classes.row}
            style={{
              display: "flex",
              justifyContent: "space-between", // Space between fields
              gap: "10px", // Add gap between fields
            }}
          >
            {/* School Logo Section */}
            <Box style={{ flex: 1 }}>
              {/* <Typography variant="body1" style={{ color: "white", marginBottom: "8px" }}>
                School Logo:
              </Typography> */}
              <div className={classes.uploadContainer}>
                <Button component="label" variant="contained" startIcon={<CloudUploadIcon />}
                style={{
                  width: "100%",
                  justifyContent: "flex-start",
                  textAlign: "left",
                  textTransform: "none",
                  minHeight: "45px", // Increased height
                }}
              >
                  {schoolLogoName === "No file chosen" ? "Choose Logo" : schoolLogoName}
                  <input
                    type="file"
                    id="schoolLogo"
                    onChange={handleFileChange}
                    name="schoolLogo"
                    className={classes.uploadInput}
                    style={{ display: "none" }}
                  />
                </Button>
              </div>
              {errors.schoolLogo && (
                <Typography variant="body2" style={{ color: "red", marginTop: "8px" }}>
                  {errors.schoolLogo}
                </Typography>
              )}
            </Box>

            {/* School Stamp Section */}
            <Box style={{ flex: 1 }}>
              {/* <Typography variant="body1" style={{ color: "white", marginBottom: "8px" }}>
                School Stamp:
              </Typography> */}
              <div className={classes.uploadContainer}>
                <Button component="label" variant="contained" startIcon={<CloudUploadIcon />}
                 style={{
                  width: "100%",
                  justifyContent: "flex-start",
                  textAlign: "left",
                  textTransform: "none",
                  minHeight: "45px", // Increased height
                }}
              >
                  {schoolStampName === "No file chosen" ? "Choose Stamp" : schoolStampName}
                  <input
                    type="file"
                    id="schoolStamp"
                    onChange={handleFileChange}
                    name="schoolStamp"
                    className={classes.uploadInput}
                    style={{ display: "none" }}
                  />
                </Button>
              </div>
              {errors.schoolStamp && (
                <Typography variant="body2" style={{ color: "red", marginTop: "8px" }}>
                  {errors.schoolStamp}
                </Typography>
              )}
            </Box>
          </Box>



          <Button
  type="submit"
  variant="contained"
  className={classes.submit}
  disabled={loading}
  style={{
    height: "45px", // Slightly increased height for better UI
    fontSize: "15px", // Improved readability
    fontWeight: "bold", // Enhancing text visibility
    marginTop: "12px",
    marginBottom: "12px",
    width: "220px", // Slightly wider for a more balanced look
    marginLeft: "auto", 
    marginRight: "auto",
    display: "block",
    backgroundColor: "#0F4C75", // Deep Blue (Matches background theme)
    color: "#FFFFFF", 
    borderRadius: "8px", // Smooth rounded corners
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)", // Adding depth
    transition: "0.3s ease-in-out", // Smooth hover effect
  }}
>
  {loading ? (
    <CircularProgress size={24} className={classes.loader} />
  ) : (
    "Submit"
  )}
</Button>
<div style={{ textAlign: "center" }}>
<Link
                    onClick={() => navigate("/")}
                    style={{
                      color: "#0F4C75",
                      fontWeight: "bold",
                      cursor: "pointer",
                      paddingLeft: "6px",
                    }}
                  >
                    Back To Sign In
                  </Link>
                  </div>

        </form>
      </Container>
      <ToastContainer />
    </div>
  );
};

export default OrganizationForm;